
































































import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';

import ModalControlsPanel from '@/components/Form/ModalControlsPanel.vue';

export default Vue.extend({
    name: 'UploadTemplateControl',
    components: {
        ModalControlsPanel,
    },
    computed: {
        ...mapGetters('viewing', {
            activeRequest: 'getActiveUploadRequest',
            failedRequest: 'getFailedUploadRequest',
            successRequest: 'getsSuccessUploadRequest',
        }),
        fileIsExsists(): boolean {
            return this.selectFile !== null;
        },
        fileName(): string {
            return this.selectFile !== null ? this.selectFile.name : '';
        },
    },
    methods: {
        ...mapActions('viewing', {
            resetFormFlags: 'resetUploadForm',
            uploadTemplate: 'uploadExcel',
        }),
        showUploadDialog() {
            (this.$refs['file'] as HTMLFormElement).click();
        },
        setSelectFile(event: InputEvent) {
            const files = (event.target as HTMLInputElement).files;
            if (files !== null && files.length > 0) {
                this.selectFile = files[0];
            }
        },
        async submitForm() {
            if (this.selectFile !== null) {
                // составим содержимое "формы"
                const file = this.selectFile;
                const formData = new FormData();
                formData.append('template', file);
                // отправим запрос на сервер
                await this.uploadTemplate(formData);
                // перезагрузим состояние формы
                (this.$refs['file'] as HTMLFormElement).value = null;
                this.selectFile = null;
                this.closeModalForm();
            }
        },
        showModal() {
            this.formShow = true;
        },
        closeModalForm() {
            this.formShow = false;
        },
        resetState() {
            (this.$refs['file'] as HTMLFormElement).value = null;
            this.resetFormFlags();
        },
    },
    mounted() {
        this.resetState();
    },
    data() {
        return {
            selectFile: null as File | null,
            formShow: false,
        };
    }
});
